module.exports = __webpack_public_path__ + "img/question11c4.da6cf7d5.png";